"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "MARKING_TYPE", {
  enumerable: true,
  get: function get() {
    return _Label.MARKING_TYPE;
  }
});
exports.SearchableSelect = exports.STYLE_TYPE = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _react = _interopRequireWildcard(require("react"));
var _reactSelect = _interopRequireWildcard(require("react-select"));
var _asyncCreatable = _interopRequireDefault(require("react-select/async-creatable"));
var _creatable = _interopRequireDefault(require("react-select/creatable"));
var _Label = require("b2b-components/theme/components/Form/Label");
var _key = require("b2b-components/utils/key");
var _classnames = _interopRequireDefault(require("classnames"));
var _upperCaseFirst = require("upper-case-first");
var _Error = require("../../common/Error");
var _Info = require("../../common/Info");
var _Control = require("./Control");
var _DropdownIndicator = require("./DropdownIndicator");
var _LoadingIndicator = require("./LoadingIndicator");
var _Option = require("./Option");
require("./SearchableSelect.scss");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      (0, _defineProperty2["default"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
var STYLE_TYPE = /*#__PURE__*/function (STYLE_TYPE) {
  STYLE_TYPE["outlined"] = "outlined";
  STYLE_TYPE["underlined"] = "underlined";
  return STYLE_TYPE;
}(STYLE_TYPE || {});
exports.STYLE_TYPE = STYLE_TYPE;
var SearchableSelect = function SearchableSelect(_ref) {
  var className = _ref.className,
    onChange = _ref.onChange,
    options = _ref.options,
    onLoadOptions = _ref.onLoadOptions,
    onInputChange = _ref.onInputChange,
    _ref$error = _ref.error,
    error = _ref$error === void 0 ? null : _ref$error,
    _ref$info = _ref.info,
    info = _ref$info === void 0 ? null : _ref$info,
    _ref$isAsynchronous = _ref.isAsynchronous,
    isAsynchronous = _ref$isAsynchronous === void 0 ? false : _ref$isAsynchronous,
    _ref$isDisabled = _ref.isDisabled,
    isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
    _ref$isCreatable = _ref.isCreatable,
    isCreatable = _ref$isCreatable === void 0 ? false : _ref$isCreatable,
    _ref$markingType = _ref.markingType,
    markingType = _ref$markingType === void 0 ? _Label.MARKING_TYPE.none : _ref$markingType,
    _ref$styleType = _ref.styleType,
    styleType = _ref$styleType === void 0 ? STYLE_TYPE.outlined : _ref$styleType,
    dropdownWidth = _ref.dropdownWidth,
    _ref$text = _ref.text,
    text = _ref$text === void 0 ? {
      creating: 'Creating',
      label: '',
      placeholder: '',
      noOptions: 'Not options found',
      required: '*',
      optional: '(optional)',
      loading: 'Loading...'
    } : _ref$text,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? '' : _ref$value;
  var Error = SearchableSelect.Error,
    Info = SearchableSelect.Info,
    Label = SearchableSelect.Label,
    Control = SearchableSelect.Control,
    DropdownIndicator = SearchableSelect.DropdownIndicator,
    Option = SearchableSelect.Option;
  var id = (0, _key.generateUnique)();
  var rootClassName = (0, _classnames["default"])('cds-Form-Input', "cds-Form-Input--".concat((0, _upperCaseFirst.upperCaseFirst)(styleType)), {
    'cds-Form-Input--Error': error
  }, className);
  var selectOptions = (0, _react.useMemo)(function () {
    var availableOptions = [];
    if (text.placeholder) {
      availableOptions.push({
        label: text.placeholder,
        value: null,
        isDisabled: true
      });
    }
    availableOptions.push.apply(availableOptions, (0, _toConsumableArray2["default"])(options));
    return availableOptions;
  }, [text.placeholder, options]);
  var findValue = (0, _react.useMemo)(function () {
    return value === null ? null : options.find(function (option) {
      return option.value === value;
    });
  }, [options, value]);
  var NoOptionsMessageComponent = (0, _react.useCallback)(function (props) {
    return /*#__PURE__*/_react["default"].createElement(_reactSelect.components.NoOptionsMessage, props, text.noOptions);
  }, [text.noOptions]);
  var commonProps = (0, _react.useMemo)(function () {
    return {
      id: id,
      defaultValue: findValue,
      value: findValue,
      isDisabled: isDisabled,
      options: selectOptions,
      className: 'cds-SearchableSelect',
      classNamePrefix: 'cds-SearchableSelect',
      onChange: onChange,
      onInputChange: onInputChange,
      isClearable: false,
      isSearchable: true,
      placeholder: text.placeholder,
      components: {
        Control: Control,
        DropdownIndicator: DropdownIndicator,
        Option: Option,
        NoOptionsMessage: NoOptionsMessageComponent,
        IndicatorSeparator: null
      },
      styles: {
        menu: function menu(baseStyles) {
          return _objectSpread(_objectSpread({}, baseStyles), {}, {
            width: dropdownWidth || '100%'
          });
        }
      },
      formatCreateLabel: function formatCreateLabel(userInput) {
        return "".concat(text.creating || '', " \"").concat(userInput, "\"");
      }
    };
  }, [Control, DropdownIndicator, findValue, id, isDisabled, onChange, onInputChange, Option, selectOptions, text.creating, text.placeholder, NoOptionsMessageComponent, dropdownWidth]);
  var asyncProps = (0, _react.useMemo)(function () {
    return {
      defaultOptions: options.length > 0 ? options : false,
      cacheOptions: true,
      loadOptions: onLoadOptions,
      components: _objectSpread(_objectSpread({}, commonProps.components), {}, {
        LoadingIndicator: _LoadingIndicator.LoadingIndicator
      }),
      loadingMessage: function loadingMessage() {
        return text.loading;
      }
    };
  }, [commonProps.components, onLoadOptions, text.loading, options]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: rootClassName
  }, text.label && /*#__PURE__*/_react["default"].createElement(Label, {
    text: text,
    markingType: markingType,
    className: "cds-Form-Label cds-SearchableSelect-Label",
    htmlFor: id
  }, text.label), isAsynchronous && isCreatable && /*#__PURE__*/_react["default"].createElement(_asyncCreatable["default"], (0, _extends2["default"])({}, commonProps, asyncProps)), !isAsynchronous && isCreatable && /*#__PURE__*/_react["default"].createElement(_creatable["default"], commonProps), !isAsynchronous && !isCreatable && /*#__PURE__*/_react["default"].createElement(_reactSelect["default"], commonProps)), error && /*#__PURE__*/_react["default"].createElement(Error, null, error), info && /*#__PURE__*/_react["default"].createElement(Info, null, info));
};
exports.SearchableSelect = SearchableSelect;
SearchableSelect.Error = _Error.Error;
SearchableSelect.Info = _Info.Info;
SearchableSelect.Label = _Label.Label;
SearchableSelect.Control = _Control.Control;
SearchableSelect.Option = _Option.Option;
SearchableSelect.DropdownIndicator = _DropdownIndicator.DropdownIndicator;
SearchableSelect.LoadingIndicator = _LoadingIndicator.LoadingIndicator;
SearchableSelect.config = {
  markingType: _Label.MARKING_TYPE,
  styleType: STYLE_TYPE
};